/**
 * All Data Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initAllData() {
    const blocks = document.querySelectorAll(".all-data");

    blocks.forEach((block) => {
      // Initialize carousel first
      initDataSlider(block);
      
      const postsContainer = block.querySelector(".team_inner_slider") || block.querySelector(".posts");
      const loadMoreButton = block.querySelector(".load-more-button");
      const loadMoreWrapper = block.querySelector(".load-more-wrapper");

      if (!postsContainer) {
        return;
      }

      // Track current state
      let currentOffset = 0;
      const postsPerPage =
        parseInt(postsContainer.getAttribute("data-posts-per-page")) || 9;

      // Store initial offset - set to number of posts already displayed
      const initialPostsCount = postsContainer.querySelectorAll(".news_post").length;
      postsContainer.setAttribute("data-current-offset", initialPostsCount.toString());

      // Handle Load More button click
      if (loadMoreButton && !loadMoreButton.hasAttribute("data-listener-attached")) {
        loadMoreButton.setAttribute("data-listener-attached", "true");
        loadMoreButton.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Prevent duplicate clicks
          if (this.disabled || this.dataset.loading === "true") {
            return;
          }
          this.dataset.loading = "true";
          
          // Get current offset by counting actual posts displayed (more reliable)
          const currentPostsCount = postsContainer.querySelectorAll(".news_post").length;
          currentOffset = currentPostsCount;
          
          // Use current offset for the request (offset will be updated in success callback)
          loadMoreData(
            block,
            postsContainer,
            loadMoreWrapper,
            currentOffset,
            postsPerPage
          ).finally(() => {
            // Reset loading flag
            if (loadMoreButton) {
              loadMoreButton.dataset.loading = "false";
            }
          });
        });
      } else {
        // Try to find the button again after a short delay (in case it's added dynamically)
        setTimeout(() => {
          const delayedButton = block.querySelector(".load-more-button");
          if (delayedButton && !delayedButton.hasAttribute("data-listener-attached")) {
            delayedButton.setAttribute("data-listener-attached", "true");
            delayedButton.addEventListener("click", function (e) {
              e.preventDefault();
              // Get current offset by counting actual posts displayed (more reliable)
              const currentPostsCount = postsContainer.querySelectorAll(".news_post").length;
              const currentOffset = currentPostsCount;
              loadMoreData(
                block,
                postsContainer,
                loadMoreWrapper,
                currentOffset,
                postsPerPage
              );
            });
          }
        }, 100);
      }
    });
  }

  /**
   * Initialize data slider
   */
  function initDataSlider(block) {
    const sliderContainer = block.querySelector(".team_inner_slider");
    const arrowsWrapper = block.querySelector(".team_slider_arrows_wrapper");
    const prevBtn = arrowsWrapper
      ? arrowsWrapper.querySelector(".carousel-arrow--prev")
      : null;
    const nextBtn = arrowsWrapper
      ? arrowsWrapper.querySelector(".carousel-arrow--next")
      : null;

    if (!sliderContainer) return;

    const items = Array.from(
      sliderContainer.querySelectorAll(".news_post")
    );
    if (items.length === 0) return;

    let currentIndex = 0;
    let itemsPerView = 1; // Mobile default

    // Get items per view based on screen size
    function getItemsPerView() {
      if (window.innerWidth >= 1024) {
        return 3; // Desktop
      } else if (window.innerWidth >= 768) {
        return 2; // Tablet
      }
      return 1; // Mobile
    }

    // Calculate max index based on items per view
    function getMaxIndex() {
      const itemsToShow = getItemsPerView();
      return Math.max(0, items.length - itemsToShow);
    }

    // Update slider position
    function updateSliderPosition() {
      itemsPerView = getItemsPerView();
      const maxIndex = getMaxIndex();

      // Clamp currentIndex to valid range
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      // Calculate the width of one item including gap
      const firstItem = items[0];
      if (!firstItem) return;

      const itemWidth = firstItem.offsetWidth;
      const gap = 35; // Gap between items
      const itemWidthWithGap = itemWidth + gap;

      // Calculate translateX value
      const translateX = -currentIndex * itemWidthWithGap;

      // Apply transform
      sliderContainer.style.transform = `translateX(${translateX}px)`;

      // Update arrow states
      updateArrows();
    }

    // Update arrow states
    function updateArrows() {
      const maxIndex = getMaxIndex();

      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
        prevBtn.classList.toggle("disabled", currentIndex === 0);
      }

      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIndex;
        nextBtn.classList.toggle("disabled", currentIndex >= maxIndex);
      }
    }

    // Next slide
    function nextSlide() {
      const maxIndex = getMaxIndex();
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSliderPosition();
      }
    }

    // Previous slide
    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateSliderPosition();
      }
    }

    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener("click", nextSlide);
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", prevSlide);
    }

    // Handle window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateSliderPosition();
      }, 100);
    });

    // Initialize
    updateSliderPosition();

    // Hide arrows if not enough items
    if (items.length <= getItemsPerView()) {
      if (prevBtn) prevBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
    }
  }

  /**
   * Reinitialize lazy loading for newly loaded content
   */
  function reinitLazyLoading(container) {
    // Try lozad - observe all new lazy elements
    if (typeof lozad !== "undefined") {
      // Find all lazy elements in the container that haven't been loaded yet
      const allLazyElements = container.querySelectorAll(".lazy");

      if (allLazyElements.length > 0) {
        // If we have an existing observer, use it
        if (window.lozadObserver) {
          // Observe all elements in container (lozad handles duplicates)
          allLazyElements.forEach((el) => {
            if (!el.hasAttribute("data-loaded")) {
              window.lozadObserver.observe(el);
            }
          });
        } else {
          // Create new observer and store it globally
          window.lozadObserver = lozad(".lazy", {
            loaded: function (el) {
              el.classList.add("loaded");
              el.setAttribute("data-loaded", "true");
              // Force layout recalculation after image loads
              void el.offsetHeight;
            },
          });
          // Observe all elements
          window.lozadObserver.observe();
        }
      }
    }

    // Try LazyLoad (common library) - use update method
    if (typeof LazyLoad !== "undefined") {
      if (window.lazyLoadInstance) {
        // Update existing instance - this will scan for new elements
        window.lazyLoadInstance.update();
      } else {
        // Create new instance
        window.lazyLoadInstance = new LazyLoad({
          elements_selector: ".lazy",
        });
        window.lazyLoadInstance.update();
      }
    }

    // Try WP Rocket lazy loading (dispatches custom event)
    if (typeof window.dispatchEvent !== "undefined") {
      const event = new CustomEvent("lazyload-update", {
        detail: { container: container },
      });
      window.dispatchEvent(event);
    }

    // Force browser to recalculate layout after a short delay
    setTimeout(() => {
      // Trigger scroll event to help lazy loading libraries detect new content
      window.dispatchEvent(new Event("scroll"));

      // Force layout recalculation by reading offsetHeight
      void container.offsetHeight;

      // Trigger resize event to help browsers recalculate page height
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  /**
   * Load more data posts via AJAX
   */
  function loadMoreData(
    block,
    container,
    loadMoreWrapper,
    offset,
    postsPerPage
  ) {
    // Show loading state
    const loadMoreButton = block.querySelector(".load-more-button");
    if (loadMoreButton) {
      loadMoreButton.disabled = true;
      loadMoreButton.textContent = "Loading...";
    }

    // Make AJAX request
    const formData = new FormData();
    formData.append("action", "all_data_load_more");
    formData.append("nonce", allDataAjax.nonce);
    formData.append("offset", offset);
    formData.append("posts_per_page", postsPerPage);

    return fetch(allDataAjax.ajaxurl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          // Append new posts
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = data.data.html;
          const newPosts = tempDiv.querySelectorAll(".news_post");

          newPosts.forEach((post) => {
            container.appendChild(post);
          });

          // Update offset after successfully loading posts - count all posts to be accurate
          const totalPostsCount = container.querySelectorAll(".news_post").length;
          container.setAttribute("data-current-offset", totalPostsCount.toString());

          // Reinitialize lazy loading for newly appended content
          reinitLazyLoading(container);

          // Force page height recalculation after images have time to load
          // This ensures the scroll area extends properly
          setTimeout(() => {
            // Force layout recalculation by reading dimensions
            void container.offsetHeight;
            void document.body.offsetHeight;
            void document.documentElement.offsetHeight;

            // Trigger resize event to help browsers recalculate
            window.dispatchEvent(new Event("resize"));
          }, 500);

          // Show/hide Load More button
          let wrapper =
            loadMoreWrapper || block.querySelector(".load-more-wrapper");
          if (!wrapper && data.data.has_more) {
            // Create wrapper if it doesn't exist
            wrapper = document.createElement("div");
            wrapper.className = "load-more-wrapper";
            const button = document.createElement("button");
            button.className = "load-more-button grey_button";
            button.type = "button";
            button.textContent = "Load more";
            wrapper.appendChild(button);
            block.querySelector(".inner").appendChild(wrapper);

            // Add click handler
            button.addEventListener("click", function () {
              // Get current offset by counting actual posts displayed (more reliable)
              const currentPostsCount = container.querySelectorAll(".news_post").length;
              const currentOffset = currentPostsCount;
              // Use current offset for the request (offset will be updated in success callback)
              loadMoreData(
                block,
                container,
                wrapper,
                currentOffset,
                postsPerPage
              );
            });
          }

          if (wrapper) {
            if (data.data.has_more) {
              wrapper.style.display = "flex";
              const button = wrapper.querySelector(".load-more-button");
              if (button) {
                button.disabled = false;
                button.textContent = "Load more";
              }
            } else {
              wrapper.style.display = "none";
            }
          }
        } else {
          console.error("Error loading data:", data.data.message);
        }
      })
      .catch((error) => {
        console.error("AJAX error:", error);
      })
      .finally(() => {
        const loadMoreButton = block.querySelector(".load-more-button");
        if (loadMoreButton) {
          loadMoreButton.disabled = false;
          loadMoreButton.textContent = "Load more";
        }
      });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllData);
  } else {
    initAllData();
  }
})();
